import { CASE_TYPE_MAP } from "../../utils/enum";
import CopyIcon from '../../assets/icons/CopyIcon.svg?react';
import { formatDateTime, formatUTCDateDash } from "@demandproai/shared";
import { useProductContext } from "../../contexts/ProductContext";
import { getCaseTypeText } from '../../utils/helper';
import { copyTextToClipboard } from "../../utils/helper";
import XPopover from "../common/XPopover";
import PopoverInfoRow from "../common/PopoverInfoRow";
import { POPOVER_PLACEMENT } from "../../utils/enum";

const cellClasses = 'h-22.5';

const titleClasses = 'font-bold text-sm';

const popoverClasses = 'py-3 px-4';

const copyIconClasses = 'cursor-pointer text-primary';

const CaseDetailsCell = ({ caseData }) => {
    const { CASE_TYPE_MAP_MT } = useProductContext();

    return (
        <td className={cellClasses}>
            <XPopover
                id={caseData._id}
                placement={POPOVER_PLACEMENT.TOP_LEFT}
                trigger={
                    <div
                        title={`Case ID: ${caseData._id}`}
                        tabIndex="0"
                    >
                        <span className={titleClasses}>
                            {caseData?.caseInfo?.caseName}
                        </span>

                        <br />

                        {getCaseTypeText({
                            caseType: caseData?.caseInfo?.caseType,
                            caseTypeMap: CASE_TYPE_MAP,
                            caseTypeMapMT: CASE_TYPE_MAP_MT,
                        })}

                        <br />

                        {caseData?.caseInfo?.stateOfIncident}{" "}
                        {caseData?.caseInfo?.stateOfIncident ? "|" : ""}{" "}
                        {formatUTCDateDash(caseData?.caseInfo?.dateOfIncident)}
                    </div>
                }
            >
                <div className={popoverClasses}>
                    <PopoverInfoRow
                        label="Case ID"
                        value={caseData?._id}
                        bold
                        rightContent={
                            <CopyIcon
                                className={copyIconClasses}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    copyTextToClipboard(caseData._id);
                                }}
                            />
                        }
                    />
                    <PopoverInfoRow
                        label="Case Type"
                        value={caseData?.caseInfo?.caseType}
                    />
                    <PopoverInfoRow
                        label="Case Added"
                        value={formatDateTime(caseData?.createdOn)}
                    />
                    <PopoverInfoRow
                        label="Latest Update"
                        value={formatDateTime(caseData?.updatedOn)}
                    />
                </div>
            </XPopover>
        </td>
    );
};

export default CaseDetailsCell;